import React, { Component } from 'react'
import Logo from "../imgs/logo.jpg";

class Form2Header extends Component {
    render() {
        return (
            <div>
                <div className="header_sec">
                    <div className="header_logo_left">
                        <a href="/">
                        {/* <img src={Logo} alt="Referral for Direct Schedule Screening Colonoscopy with Dr. Yamini Maddala" /> */}
                        </a>
                    </div>
                    <div className="header_right">
                        <p>Yamini Maddala, M.D.,</p>
                        <p>
                        Phone: <span className="pno">972-408-4400</span>
                        </p>
                    </div>
                </div>
                <div className="address_section">
                    <div className="address_item">
                        <p className="address_title">Frisco</p>
                        <p>12530 Lebanon Rd,</p>
                        <p>Suite 202,</p>
                        <p>Prosper, TX 75035</p>
                        <p>(972) 408-4400</p>
                        <p>(972) 408-4422 Fax</p>
                    </div>
                    <div className="address_item">
                        <p className="address_title">McKinney</p>
                        <p>2152 N Lake Forest Drive,</p>
                        <p>Suite 408,</p>
                        <p>McKinney, TX 75071</p>
                        <p>(972) 408-4400</p>
                        <p>(972) 408-4422 Fax</p>
                    </div>
                    <div className="address_item address_item_main">
                        <p className="address_title">Allen (main)</p>
                        <p>981 State Highway 121,</p>
                        <p>Suite 1140,</p>
                        <p>Allen, TX 75013</p>
                        <p>(972) 408-4400</p>
                        <p>(972) 408-4422 Fax</p>
                    </div>
                    <div className="address_item">
                        <p className="address_title">Prosper</p>
                        <p>210 S Preston Road,</p>
                        <p>Suite 10,</p>
                        <p>Prosper, TX 75078</p>
                        <p>(972) 408-4400</p>
                        <p>(972) 408-4422 Fax</p>
                    </div>
                    <div className="address_item">
                        <p className="address_title">Anna</p>
                        <p>450 N Standridge Blvd,</p>
                        <p>Suite 102,</p>
                        <p>Anna, TX 75409</p>
                        <p>(972) 408-4400</p>
                        <p>(972) 408-4422 Fax</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default Form2Header